// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ff935228","239":"1d82f4cb","455":"32f696bf"}[chunkId] + ".chunk.js";
};